import styled from "styled-components/macro";
import { space, colors, borderRadius } from "shared/styles/constants";
import { defaultLink } from "shared/styles/defaults";

export const StyledFileField = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  margin: -${space.xxs};

  > * {
    margin: ${space.xxs};
  }
`;

export const StyledFileUrl = styled.a`
  ${defaultLink()}

  svg {
    margin-right: ${space.xxs};
  }
`;

export const DropZone = styled.div<{ isDragActive: boolean }>`
  border: 2px dashed
    ${({ isDragActive }) => (isDragActive ? colors.blue : colors.grey3)};
  border-radius: ${borderRadius.m};
  padding: ${space.m};
  display: flex;
  gap: ${space.m};
  align-items: center;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${({ isDragActive }) =>
    isDragActive ? colors.grey1 : "transparent"};

  &:hover {
    border-color: ${colors.blue};
    background-color: ${colors.grey1};
  }
`;
